<h4 mat-dialog-title>
  <span *ngIf="!data;else editHeader">
    Creazione nuova compagnia assicurativa
  </span>
  <ng-template #editHeader>
    Modifica compagnia assicurativa {{data.nome}}
  </ng-template>
</h4>

<form [formGroup]="form" class="mt-4" (keydown.enter)="edit()">

  <div>
    <mat-form-field>
      <mat-label>Nome</mat-label>
      <input matInput formControlName="nome">
      <mat-icon matSuffix>nome</mat-icon>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field>

      <mat-label>
        Via / piazza
      </mat-label>
      <input matInput formControlName="via">
    </mat-form-field>

    <mat-form-field>
      <mat-label>
        N. civico
      </mat-label>
      <input matInput formControlName="civico">
    </mat-form-field>

    <mat-form-field>
      <mat-label>
        Comune
      </mat-label>
      <comune-picker formControlName="comune"></comune-picker>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Gruppo</mat-label>
      <gruppo-picker formControlName="gruppo"></gruppo-picker>
    </mat-form-field>
    <mat-form-field>
      <mat-label>
        Telefono
      </mat-label>
      <input matInput formControlName="tel">
    </mat-form-field>
    <mat-form-field>
      <mat-label>
        Cellulare
      </mat-label>
      <input matInput formControlName="cell">
    </mat-form-field>
    <mat-form-field>
      <mat-label>
        Fax
      </mat-label>
      <input matInput formControlName="fax">
    </mat-form-field>
    <mat-form-field>
      <mat-label>
        Email
      </mat-label>
      <input matInput formControlName="email">
    </mat-form-field>
  </div>

  <div class="concordato-toggle mt-3 mb-3">
    <mat-slide-toggle formControlName="concordato_visibile">
      Concordato visibile
    </mat-slide-toggle>
  </div>
</form>
<button mat-raised-button (click)="edit()" color="primary">Salva</button>